import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Utilization from './components/Utilization';
import Sports from './components/Sports';
import Ecosystem from './components/Ecosystem';
import Audiences from './components/Audiences';
import BrandedApp from './components/BrandedApp';
import Analytics from './components/Analytics';
import Plans from './components/Plans';
import About from './components/About';
import Cta from './components/Cta';
import Demo from './components/Demo';
import Footer from './components/Footer';

import { useReveal } from './hooks/useReveal';
import { useScrollChrome } from './hooks/useScrollChrome';
import { useParallax } from './hooks/useParallax';
import { usePointerGlow } from './hooks/usePointerGlow';

/** sections the nav highlights as you scroll past them */
const NAV_SECTIONS = ['features', 'sports', 'plans', 'about'];

export default function App() {
  const { stuck, activeId } = useScrollChrome(NAV_SECTIONS);

  useReveal();
  useParallax();
  usePointerGlow();

  return (
    <>
      <Header activeId={activeId} stuck={stuck} />

      <main id="top">
        <Hero />
        <Features />
        <Utilization />
        <Sports />
        <Ecosystem />
        <Audiences />
        <BrandedApp />
        <Analytics />
        <Plans />
        <About />
        <Cta />
        <Demo />
      </main>

      <Footer />
    </>
  );
}
